import { render, staticRenderFns } from "./DialogPlanFee.pug?vue&type=template&id=5b9f8e9d&lang=pug&"
import script from "./DialogPlanFee.vue?vue&type=script&lang=js&"
export * from "./DialogPlanFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports